export var ERenderMode;
(function (ERenderMode) {
    ERenderMode[ERenderMode["CELL"] = 0] = "CELL";
    ERenderMode[ERenderMode["GROUP"] = 1] = "GROUP";
    ERenderMode[ERenderMode["SUMMARY"] = 2] = "SUMMARY";
})(ERenderMode || (ERenderMode = {}));
//# sourceMappingURL=interfaces.js.map